import 'css-chunksrc/client/scenes/editTaskStatus/styles.scss';export default {
  "header": "_header_1h8jx_1",
  "title": "_title_1h8jx_5",
  "main": "_main_1h8jx_11",
  "buttons": "_buttons_1h8jx_21",
  "confirmButton": "_confirmButton_1h8jx_31"
};